import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        return (
            <div className="bg-light">
                <NavMenu />
                <Container className="bg-light ">
                    {this.props.children}
                </Container>
            </div>
        );
    }
}